define([
    'text!./templates/wizard-content.html'
], (templateStr)=> {
    return function () {
        return {
            replace: true,
            transclude: true,
            template: templateStr,
            require: '^?gwPortalNavBar',
            link(scope, element, attrs, navBarCtrl) {
                scope.sidebarMenuVisible = () => navBarCtrl.isSideBarMenuVisible();
                if (navBarCtrl) {
                    scope.hideSidebarMenu = () => {
                        navBarCtrl.hideSideBarMenu();
                    };
                }
            }
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/wizard/WizardContentDirective.js
 **/